<template>
  <Loading v-if="statsSwrv.isValidating.value" title="Loading Stats..." />
  <div class="home-top-div">
    <nav>
      <div class="nav-buttons">
        <img
          @click="gotoHome"
          src="@/assets/home_logo.svg"
          alt="Home"
          class="home-icon"
        />
        <span
          @click="gotoContact"
          :class="{ active: isActive('/contact').value }"
          >Contact Info</span
        >
        <span @click="gotoDealer" :class="{ active: isActive('/dealer').value }"
          >Dealer</span
        >
        <span
          v-if="!callbackUrl"
          @click="gotoIdentities"
          :class="{ active: isActive('/identities').value }"
          >Identities</span
        >
        <template v-if="isDealer">
          <span class="dealer" @click="gotoUsersAdmin">Manage Users</span>
        </template>
        <template v-if="isAdmin">
          <div
            class="admin-container"
            @mouseenter="showAdminOptions = true"
            @mouseleave="showAdminOptions = false"
          >
            <span>Admin</span>
            <div v-if="showAdminOptions" class="admin-options">
              <button @click="gotoValidationAdmin" class="admin">
                User Search
              </button>
              <button @click="gotoAuth0Admin" class="admin">
                Merge Accounts
              </button>
              <button @click="gotoDealersAdmin" class="admin">Dealers</button>
              <button @click="gotoOrganizationsAdmin" class="admin">
                Organizations
              </button>
            </div>
          </div>
        </template>
      </div>

      <button @click="toggleShowHamburgerMenu" class="icon hamburger-menu">
        <span class="material-icons"
          >{{ data.showHamburgerMenu ? "close" : "menu" }}
        </span>
      </button>
      <span v-if="!callbackUrl" class="logout-link">
        <router-link to="/logout">Logout</router-link>
      </span>
      <span class="profile-dropdown-wrapper">
        <span class="material-icons profile-icon">account_circle</span>
        <div class="profile-dropdown">
          <button @click="gotoLogout" class="dropdown-btn">Logout</button>
          <button @click="openAccOptionsModal" class="dropdown-btn danger">
            Delete Account
          </button>
        </div>
      </span>

      <span v-if="callbackUrl" class="mobile-back-bttn">
        <button @click="exitInAppBrowser">
          <span class="material-icons">arrow_back</span>Back To App
        </button>
      </span>
    </nav>

    <template v-if="data.showHamburgerMenu">
      <div class="mt-1">
        <HamburgerMenu :isAdmin="isAdmin" :onClose="toggleShowHamburgerMenu" />
      </div>
    </template>
    <template v-else>
      <div style="margin-top: 2rem">
        <CompanyLogo class="company-logo" />
      </div>

      <template v-if="!isNested && !statsSwrv.isValidating.value">
        <div v-if="!stats.length" class="promo-card">
          <h2 class="promo-title">Get Started with Push for Pickup!</h2>
          <p class="promo-desc">
            No stats yet. Download our app to request pickups and start tracking
            your recycling progress.
          </p>
          <div class="promo-buttons">
            <a
              href="https://play.google.com/store/apps/details?id=com.revolutioncompany.pfpu&hl=en_US"
              target="_blank"
              rel="noopener"
              class="store-btn"
            >
              <img
                src="@/assets/google-play-badge.png"
                alt="Get it on Google Play"
                class="store-logo"
              />
            </a>
            <a
              href="https://apps.apple.com/us/app/push-for-pick-up/id1550829414"
              target="_blank"
              rel="noopener"
              class="store-btn"
            >
              <img
                src="@/assets/app-store-badge.svg"
                alt="Download on the App Store"
                class="store-logo"
              />
            </a>
          </div>
        </div>
        <div v-else class="dashboard-container">
          <div v-if="stats.length" class="welcome-section">
            <h1 class="welcome-message">
              Welcome, <span class="welcome-name">{{ userName }}</span>
            </h1>
          </div>
          <div class="card map-card" v-if="locations.length">
            <div class="location-header">
              <div class="title-and-legend">
                <span class="chart-title">Locations</span>
                <div class="map-legend">
                  <div class="legend-item">
                    <div class="legend-dot" style="background: #4caf50"></div>
                    <span>Available for Request</span>
                  </div>
                  <div class="legend-item">
                    <div class="legend-dot" style="background: #ff4444"></div>
                    <span>Has Open Request</span>
                  </div>
                </div>
              </div>
              <div class="location-counter">
                <span class="location-number">{{ locations.length }}</span>
                <span class="location-label">Locations Owned</span>
              </div>
            </div>
            <MapCard :locations="locations" />
          </div>
          <div class="card" v-if="openRequestsData.total">
            <span class="chart-title">Open Requests</span>
            <span class="counter">{{ openRequestsData.total }}</span>

            <span class="last-request" v-if="openRequestsData.days"
              >Last request: {{ openRequestsData.days }}</span
            >
            <!-- <button class="view-requests-btn">View All</button> -->
          </div>
          <div class="card" v-if="rebateSupported && hasRebateData">
            <span class="chart-title">Rebates</span>
            <div style="width: 100%; height: 300px">
              <PieChart
                :data="rebatePieChartData.data"
                :labels="rebatePieChartData.labels"
                :colors="rebatePieChartData.colors"
              />
            </div>
          </div>

          <div class="card" v-if="requestsLineChartData.data.length">
            <span class="chart-title">Number of Requests</span>
            <div class="linechart-wrapper">
              <LineChart
                :labels="requestsLineChartData.labels"
                :data="requestsLineChartData.data"
              />
            </div>
          </div>
          <div class="card" v-if="materialBarChartData.materialTotal">
            <span class="chart-title">Material Recycled</span>
            <span class="material-total"
              >({{
                materialBarChartData.materialTotal
                  ? materialBarChartData.materialTotal.toLocaleString()
                  : 0
              }}
              lbs)</span
            >
            <div style="width: 100%; height: 300px">
              <BarChart
                :datasets="materialBarChartData.datasets"
                :labels="materialBarChartData.labels"
                :colors="materialBarChartData.colors"
              />
            </div>
          </div>
        </div>

        <template v-if="isNested">
          <span class="ml-1">
            <router-link to="/">Back</router-link>
          </span>
        </template>
      </template>

      <template v-else>
        <div class="router-view-wrapper">
          <router-view />
        </div>
      </template>
    </template>
  </div>
  <Modal
    :isOpen="accOptionsModalVisible"
    @update:isOpen="closeAccOptionsModal"
    :closeButton="true"
  >
    <div class="other-account-options-wrapper">
      <OtherAccountOptions
        v-if="!isNested"
        :verificationValue="verificationValue"
      />
    </div>
  </Modal>
</template>

<script setup>
import { computed, onMounted, ref, reactive, inject } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter, useRoute } from "vue-router";
import OtherAccountOptions from "../components/OtherAccountOptions.vue";
import CompanyLogo from "../components/CompanyLogo.vue";
import HamburgerMenu from "../components/HamburgerMenu.vue";
import PieChart from "../components/PieChart.vue";
import BarChart from "../components/BarChart.vue";
import useSwrv from "swrv";
import LineChart from "../components/LineChart.vue";
import MapCard from "../components/MapCard.vue";
import Modal from "../components/Modal.vue";

const ROLES_URL = `https://deltaplastics.com/roles`;
const STATS_URL = "/api/users/stats";
const PLASTIC_TYPE_GROUPS = [
  "",
  "N/A",
  "Polytube",
  "Silage",
  "Other",
  "Grain Bags",
  "Almond",
  "Vine",
  "Stretch Film",
];
const $auth0 = useAuth0();
const $api = inject("$api");
const router = useRouter();
const route = useRoute();

const callbackUrl = ref(null);
const showAdminOptions = ref(false);
const userInformation = ref(null);
const accOptionsModalVisible = ref(false);

const userName = computed(() => {
  return userInformation.value?.userInformation?.first_name || "User";
});

const isAdmin = computed(() => {
  const user = $auth0.user?.value;
  if (!user) {
    return false;
  }

  return user[ROLES_URL]?.includes("MyAccount Admin");
});

const isDealer = computed(() => {
  const user = $auth0.user?.value;
  if (!user) {
    return false;
  }

  return user[ROLES_URL]?.includes("MyAccount Dealer");
});

const statsSwrv = useSwrv(STATS_URL, () => $api.getUserStats(), {
  revalidateOnFocus: false,
});
const stats = computed(() => statsSwrv.data?.value || []);

function parsePoint(pointStr) {
  const [lng, lat] = pointStr
    .replace("POINT (", "")
    .replace(")", "")
    .split(" ")
    .map(Number);
  return { lat, lng };
}

const locations = computed(() => {
  return (
    stats.value
      .filter((s) => s.stat_type === "locations")
      .map((loc) => {
        const { lat, lng } = parsePoint(loc.dim2);
        return {
          lat,
          lng,
          name: loc.dim1,
          id: loc.id || loc.dim1,
          hasOpenRequest: loc.stat_value === "1",
        };
      }) || []
  );
});

const rebateSupported = computed(() => {
  const statesWithRebates = ["LA", "TX", "MS", "AR", "TN", "MO", "IL"];
  return statesWithRebates.includes(
    userInformation.value?.userInformation?.state,
  );
});

const rebatePieChartData = computed(() => {
  if (!stats.value) return { labels: [], data: [], colors: [] };
  const labels = ["Redeemed", "Balance"];
  const colors = ["#4caf50", "#90caf9"];
  const redeemed = stats.value.find((s) => s.stat_type === "redeemed");
  const balance = stats.value.find((s) => s.stat_type === "balance");
  const data = [
    redeemed ? redeemed.stat_value : 0,
    balance ? balance.stat_value : 0,
  ];
  return { labels, data, colors };
});

const hasRebateData = computed(() => {
  if (!rebatePieChartData.value?.data) return false;
  return rebatePieChartData.value.data.some((value) => value > 0);
});

const materialBarChartData = computed(() => {
  if (!stats.value) return { labels: [], datasets: [], colors: [] };
  const years = [
    ...new Set(
      stats.value.filter((s) => s.stat_type === "material").map((s) => s.dim1),
    ),
  ];
  const categories = [
    ...new Set(
      stats.value.filter((s) => s.stat_type === "material").map((s) => s.dim2),
    ),
  ];

  const colorPalette = ["#09e6a0", "#1d9ad6", "#3aae49", "#f27935", "#8cb7c9"];

  const datasets = categories.map((cat, idx) => ({
    label: PLASTIC_TYPE_GROUPS[cat],
    data: years?.map((year) => {
      const found = stats.value.find(
        (s) => s.stat_type === "material" && s.dim1 === year && s.dim2 === cat,
      );
      return found ? Number(found.stat_value) : 0;
    }),
    backgroundColor: colorPalette[idx % colorPalette.length],
  }));

  const materialTotal = stats.value
    .filter((s) => s.stat_type === "material")
    .reduce((sum, s) => sum + (Number(s.stat_value) || 0), 0);
  return { labels: years, datasets, colors: colorPalette, materialTotal };
});

const requestsLineChartData = computed(() => {
  if (!stats.value) return { labels: [], data: [], colors: [] };
  const monthsOfYear = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const requests = stats.value.filter((s) => s.stat_type === "requests") || [];
  const requestsByYear = {};
  requests.forEach((req) => {
    const year = req.dim1;
    const monthIdx = Number(req.dim2) - 1;
    if (!requestsByYear[year]) requestsByYear[year] = Array(12).fill(0);
    requestsByYear[year][monthIdx] = Number(req.stat_value);
  });

  const colorPalette = ["#1d9ad6", "#3aae49", "#f27935", "#8cb7c9", "#09e6a0"];
  const data = Object.entries(requestsByYear).map(([year, dataArr], idx) => ({
    label: year,
    data: dataArr,
    borderColor: colorPalette[idx % colorPalette.length],
    backgroundColor: "transparent",
    tension: 0.3,
  }));

  return { labels: monthsOfYear, data };
});

//helper function to calculate days ago
function daysAgo(dateString) {
  if (!dateString) return "";
  const cleanDateString =
    dateString.split(" ")[0] +
    "T" +
    dateString.split(" ")[1].split(".")[0] +
    "Z";
  const requestDate = new Date(cleanDateString);
  const now = new Date();
  const diffTime = now - requestDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "1 day ago";
  return `${diffDays} days ago`;
}
const openRequestsData = computed(() => {
  if (!stats.value) return 0;
  const openReq = stats.value.find((s) => s.stat_type === "open_requests");
  const days = daysAgo(openReq?.dim1);
  return { total: openReq ? openReq.stat_value : 0, days };
});

const data = reactive({
  showHamburgerMenu: false,
});

const rawJson = computed(() => $auth0?.user?.value?.rawJson || {});
const verificationValue = computed(() => {
  const isMobileUser = $auth0?.user?.value?.rawJson?.user_id.includes("sms");
  if (isMobileUser) {
    return rawJson.value?.phone_number.slice(2);
  }
  return rawJson.value?.email;
});

onMounted(() => {
  const split = window.location.href.split("?");
  if (split.length <= 1) {
    callbackUrl.value = null;
    return;
  }

  const paramString = split[1];
  let params = new URLSearchParams(paramString);
  if (params.has("callback")) {
    callbackUrl.value = params.get("callback");
  } else {
    callbackUrl.value = null;
  }
});

onMounted(async () => {
  try {
    const response = await $api.getUserInformation();
    userInformation.value = response;
  } catch (error) {
    console.error("Error fetching user info:", error);
  }
});

function toggleShowHamburgerMenu() {
  data.showHamburgerMenu = !data.showHamburgerMenu;
}

const callbackQuery = computed(() => {
  return callbackUrl.value ? { callback: callbackUrl.value } : {};
});
function gotoHome() {
  router.push({ path: "/", query: callbackQuery.value });
}
function gotoContact() {
  router.push({ path: "/contact", query: callbackQuery.value });
}

function gotoDealer() {
  router.push({ path: "/dealer", query: callbackQuery.value });
}

function gotoIdentities() {
  router.push({ path: "/identities", query: callbackQuery.value });
}

function gotoValidationAdmin() {
  router.push({ path: "/validation-admin", query: callbackQuery.value });
  showAdminOptions.value = false;
}

function gotoAuth0Admin() {
  router.push({ path: "/auth0-admin", query: callbackQuery.value });
  showAdminOptions.value = false;
}

function gotoDealersAdmin() {
  router.push({ path: "/dealers-admin", query: callbackQuery.value });
  showAdminOptions.value = false;
}

function gotoUsersAdmin() {
  router.push({ path: "/users-admin", query: callbackQuery.value });
}

function gotoOrganizationsAdmin() {
  router.push({ path: "/organizations-admin", query: callbackQuery.value });
}

const isNested = computed(() => {
  return route.matched.length > 1;
});

function gotoLogout() {
  router.push("/logout");
}

function openAccOptionsModal() {
  accOptionsModalVisible.value = true;
}

function closeAccOptionsModal() {
  accOptionsModalVisible.value = false;
}

const isActive = (path) => computed(() => route.path === path);

function exitInAppBrowser() {
  if (route.query?.callback) {
    const winProxy = window.open(new URL(route.query?.callback), "_top");
    winProxy.close();
  } else if (callbackUrl.value) {
    window.location = callbackUrl.value;
  } else {
    window.open("", "_self").close();
  }
}
</script>

<style lang="css" scoped>
.home-icon {
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-right: 0.5rem;
}

.home-top-div {
  background: var(--bg1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
  min-height: 100vh;
  box-sizing: border-box;
}

.admin-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0 var(--padding);
}

.admin-container span {
  color: var(--fg1);
}

.admin-container a {
  text-decoration-color: var(--fg0);
}

.mobile-back-bttn button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--padding);
}

.hambuger-menu {
  display: block;
}

.company-logo {
  display: none;
}

.nav-buttons {
  display: none;
}

.nav-buttons span {
  margin: 0 var(--padding);
  cursor: pointer;
  color: var(--fg0);
}

.nav-buttons span:hover {
  text-decoration: underline;
}

.admin-container {
  position: relative;
  display: inline-block;
}

.admin-options {
  position: absolute;
  top: 100%;
  left: 0;
  background: var(--bg1);
  border: 1px solid #ccc;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.admin-options .admin {
  background: var(--bg0);
  border: none;
  padding: 8px 15px;
  text-align: left;
  cursor: pointer;
  width: 100%;
  color: var(--fg0);
}

.admin-options .admin:hover {
  background: var(--bg2);
}

nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: relative;
  column-gap: var(--padding);
  background: var(--bg2);
  padding: var(--padding);
  align-items: center;
  padding-top: var(--padding);
  box-sizing: border-box;
}

.router-view-wrapper {
  flex-grow: 1;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0 var(--padding);
}

/*desktop view*/
@media (min-width: 800px) {
  .router-view-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    max-width: 60rem;
  }

  .active {
    text-decoration: underline;
  }

  .nav-buttons {
    display: flex;
    align-items: center;
  }

  .hamburger-menu {
    display: none;
  }
  .logout-link {
    display: none;
  }

  .company-logo {
    display: block;
  }

  .home-top-div {
    min-width: 60vw;
    min-height: 50vh;
    width: initial;
    height: initial;
  }

  nav {
    background: transparent;
    padding: 1rem;
    box-sizing: border-box;
  }
  .dashboard-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    max-width: 80rem;
  }
  .card {
    background: var(--bg2, #fff);
    border-radius: 1.25rem;
    box-shadow:
      0 4px 24px rgba(0, 0, 0, 0.1),
      0 1.5px 6px rgba(0, 0, 0, 0.06);
    padding: 2rem 2.5rem;
    margin: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 220px;
    max-width: 620px;
    transition: box-shadow 0.2s;
    height: 350px;
  }

  .card .counter {
    display: flex;
    align-items: center;
    font-size: 8rem;
    font-weight: 700;
    color: var(--accent, #2d8cf0);
    letter-spacing: 0.05em;
    text-shadow: 0 2px 8px rgba(45, 140, 240, 0.08);
    transition: color 0.2s;
    height: 350px;
  }
  .card .counter-label {
    font-size: 1rem;
    color: var(--fg1, #555);
    opacity: 0.85;
    letter-spacing: 0.03em;
  }
  .card .chart-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: var(--fg1, #222);
    letter-spacing: 0.02em;
    margin: 0;
  }
  .material-total {
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--accent0, #1d9ad6);
    margin-left: 0.5rem;
    opacity: 0.85;
    margin-bottom: 0.5rem;
  }
  .linechart-wrapper {
    width: 40rem;
    height: 300px;
  }
  .map-card {
    width: 100%;
    grid-column: 1 / -1;
  }

  .location-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .title-and-legend {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .map-legend {
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .legend-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .location-counter {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .location-number {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--accent, #2d8cf0);
  }

  .location-label {
    font-size: 0.9rem;
    color: var(--fg1, #555);
    opacity: 0.85;
  }
}
@media (max-width: 799px) {
  .linechart-wrapper {
    width: 100%;
    height: 300px;
  }

  .map-card {
    width: 98vw;
    padding: 1rem;
    margin: 0.5rem 0;
  }

  .location-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
  }

  .title-and-legend {
    width: 100%;
  }

  .map-legend {
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.75rem;
  }

  .legend-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    gap: 0.5rem;
  }

  .legend-dot {
    min-width: 10px;
    width: 10px;
    min-height: 10px;
    height: 10px;
    border-radius: 50%;
    display: block;
    flex-shrink: 0;
  }

  .location-counter {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 1rem;
  }

  .location-number {
    font-size: 2rem;
  }

  .location-label {
    font-size: 0.8rem;
  }

  .card .chart-title {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }
  .profile-dropdown-wrapper {
    display: none;
  }
}
button.admin {
  background: #f27935;
}

nav a {
  opacity: 1;
  animation: FadeIn 0.15s ease-in-out;
  color: var(--fg1);
}

.dashboard-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 80rem;
}
.card {
  background: var(--bg2, #fff);
  border-radius: 1.25rem;
  box-shadow:
    0 4px 24px rgba(0, 0, 0, 0.1),
    0 1.5px 6px rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 320px;
  max-width: 620px;
  transition: box-shadow 0.2s;
}

.card .counter {
  font-size: 8rem;
  font-weight: 700;
  color: var(--accent, #2d8cf0);
  letter-spacing: 0.05em;
  text-shadow: 0 2px 8px rgba(45, 140, 240, 0.08);
  transition: color 0.2s;
}
.card .counter-label {
  font-size: 1rem;
  color: var(--fg1, #555);
  opacity: 0.85;
  letter-spacing: 0.03em;
}
.card .chart-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--fg1, #222);
  letter-spacing: 0.02em;
  margin: 0;
}
.material-total {
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--accent0, #1d9ad6);
  margin-left: 0.5rem;
  opacity: 0.85;
  margin-bottom: 0.5rem;
}

.last-request {
  font-size: 0.85rem;
  opacity: 0.7;
}

.welcome-section {
  width: 100%;
  margin-left: 5rem;
}

.welcome-message {
  font-size: 1.75rem;
  font-weight: 500;
  color: var(--fg1);
  margin-bottom: 0.5rem;
}

.welcome-name {
  color: var(--accent0);
  font-weight: 600;
}

.promo-card {
  background: var(--bg2, #fff);
  border-radius: 1.25rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 2rem 2.5rem;
  margin: 2rem 0;
  max-width: 420px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.promo-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--accent0, #1d9ad6);
  margin-bottom: 1rem;
}

.promo-desc {
  font-size: 1rem;
  color: var(--fg1, #555);
  margin-bottom: 1.5rem;
}

.promo-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.store-btn {
  display: inline-block;
  transition: transform 0.2s;
}

.store-btn:hover {
  transform: scale(1.05);
}

.store-logo {
  height: 48px;
  width: auto;
}

button:hover {
  cursor: pointer;
}

.profile-dropdown-wrapper {
  position: relative;
}

.profile-icon {
  font-size: 2rem;
  border-radius: 50%;
  cursor: pointer;
  transition: box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.profile-dropdown {
  display: none;
  position: absolute;
  right: 0;
  top: 100%;
  margin-bottom: 1rem;
  background: var(--bg2, #fff);
  border-radius: 0.75rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 140px;
  padding: 0.5rem 0;
  flex-direction: column;
  z-index: 100;
}

.profile-dropdown-wrapper:hover .profile-dropdown,
.profile-dropdown-wrapper:focus-within .profile-dropdown {
  display: flex;
}
.dropdown-btn {
  border: none;
  padding: 0.75rem 1.25rem;
  text-align: left;
  font-size: 1rem;
  color: var(--fg1, #222);
  cursor: pointer;
  background-color: transparent !important;
}

.dropdown-btn:hover {
  box-shadow: none;
}

.dropdown-btn.danger {
  color: rgba(218, 55, 55, 0.884);
}
</style>
